// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { cashout as cashoutAction } from '../../../actions/cashout';
import HistoryItem from '../../../components/HistoryItem/HistoryItem';
import makeHistoryItemPropsSelector from '../../../components/HistoryItem/HistoryItem.selector';
import useMergeProps from '../../../hooks/useMergeProps';
import useRouter from '../../../hooks/useRouter';
import { makeEntitiesBetslipsEntityStateByBetslipRefSelector } from '../../../selectors/betslip.selector';

type HistoryItemContainerProps = {
  className?: string;
  betslipReference: string;
};

const MPHistoryItemContainer = (ownProps: HistoryItemContainerProps) => {
  const { betslipReference } = ownProps;
  const { history } = useRouter();
  const dispatch = useDispatch();

  const selectBetslip = useMemo(() => makeEntitiesBetslipsEntityStateByBetslipRefSelector(), []);
  const betslip = useSelector((state) => selectBetslip(state, { betslipReference }));
  const selectorProps = useMemo(() => ({ id: betslip?.betslipId, history }), [betslip?.betslipId, history]);
  const selector = useMemo(() => makeHistoryItemPropsSelector(), []);
  const selectedProps = useSelector((state) => selector(state, selectorProps));

  const cashout = useCallback(
    (id, expectedValue, cashoutAmount) => {
      dispatch(cashoutAction(id, expectedValue, cashoutAmount));
    },
    [dispatch],
  );

  const otherProps = useMemo(() => ({ cashout, id: betslip?.betslipId }), [cashout, betslip?.betslipId]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  if (!betslip?.betslipId) {
    return null;
  }

  return <HistoryItem {...enhancedProps} />;
};

export default MPHistoryItemContainer;
